import React from "react";
import { Box, Typography, Button, makeStyles } from "@material-ui/core";
import { colors } from "../../enhancedRoutePlans/tools";

interface MapRouteLegendProps {
  showFollowButton?: boolean;
  isFollowingBus?: boolean;
  onToggleFollow?: () => void;
}

const useStyles = makeStyles((theme) => ({
  legendContainer: {
    position: "absolute",
    bottom: "30px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1001,
    backgroundColor: "rgba(255, 255, 255, 1)",
    padding: "8px 16px",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    display: "flex",
    alignItems: "center",
    gap: "20px",
    width: "max-content",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      gap: "8px",
      padding: "8px 12px",
      bottom: "20px",
      width: "90%",
      maxWidth: "360px",
      justifyContent: "center",
    },
  },
  followSection: {
    display: "flex",
    alignItems: "center",
    borderLeft: "1px solid #ccc",
    paddingLeft: "20px",
    [theme.breakpoints.down("sm")]: {
      borderLeft: "none",
      paddingLeft: 0,
    },
  },
}));

const MapRouteLegend = React.forwardRef<HTMLDivElement, MapRouteLegendProps>(
  ({ showFollowButton, isFollowingBus, onToggleFollow }, ref) => {
    const classes = useStyles();

    return (
      <div ref={ref} className={classes.legendContainer}>
        <Box style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Box
            style={{
              width: "24px",
              height: "4px",
              backgroundColor: colors[0].colorOne,
              borderRadius: "2px",
            }}
          />
          <Typography
            variant="body2"
            style={{ color: "#2B3674", fontWeight: 500 }}
          >
            Planned Routes
          </Typography>
        </Box>
        <Box style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Box
            style={{
              width: "24px",
              height: "4px",
              backgroundColor: "#ff5722",
              borderRadius: "2px",
            }}
          />
          <Typography
            variant="body2"
            style={{ color: "#2B3674", fontWeight: 500 }}
          >
            Real Routes
          </Typography>
        </Box>

        {showFollowButton && (
          <Box className={classes.followSection}>
            <Button
              variant="outlined"
              size="small"
              style={{
                textTransform: "none",
                borderColor: isFollowingBus ? "#F87171" : "#05CD99",
                color: isFollowingBus ? "#F87171" : "#05CD99",
                fontWeight: "bold",
                borderRadius: "20px",
              }}
              onClick={onToggleFollow}
            >
              {isFollowingBus ? "Unfollow Bus" : "Follow Bus"}
            </Button>
          </Box>
        )}
      </div>
    );
  },
);

MapRouteLegend.displayName = "MapRouteLegend";

export default MapRouteLegend;
